import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center bg-white">
      <div className="container-x py-20 text-center max-w-xl mx-auto">
        <div className="text-7xl font-semibold tracking-tight text-ink-900">404</div>
        <h1 className="mt-3 text-2xl font-semibold">We couldn't find that page.</h1>
        <p className="mt-3 text-ink-600">
          The link you followed may be broken, or the page may have moved.
        </p>
        <Link to="/" className="btn-brand mt-8">
          <Home size={16} /> Back to home
        </Link>
      </div>
    </section>
  );
}
